/* istanbul ignore file */
/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { DatePipe } from '@angular/common';
import dayjs, { OpUnitType } from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import isoWeek from 'dayjs/plugin/isoWeek';
import isoWeeksInYear from 'dayjs/plugin/isoWeeksInYear';
import isLeapYear from 'dayjs/plugin/isLeapYear';

if (dayjs) {
  dayjs.extend(isBetween);
  dayjs.extend(isoWeek);
  dayjs.extend(isoWeeksInYear);
  dayjs.extend(isLeapYear);
}

/**
 * @deprecated The method should not be used, Use CommonUtils instead
 */
export class DateConverter {
  static pipe = new DatePipe('fr');

  static convertDateToTime(date: Date, withSeconds?: boolean): string {
    if (withSeconds) {
      return DateConverter.pipe.transform(date, 'HH:mm:ss');
    } else {
      return DateConverter.pipe.transform(date, 'HH:mm');
    }
  }

  static startOfTheWeek(date: Date): Date {
    const m = dayjs(date);
    return m.startOf('isoWeek').toDate();
  }

  static endOfTheWeek(date: Date): Date {
    const m = dayjs(date);
    return m.endOf('isoWeek').toDate();
  }

  static startOfTheMonth(date: Date): Date {
    const m = dayjs(date);
    return m.startOf('month').toDate();
  }

  static endOfTheMonth(date: Date): Date {
    const m = dayjs(date);
    return m.endOf('month').toDate();
  }

  static addTimeToDate(date: Date, time: string) {
    const split = time.split(':');
    if (split.length >= 2) {
      const hours = parseFloat(split[0]);
      const minutes = parseFloat(split[1]);
      if (split.length === 3) {
        const sec = parseFloat(split[2]);
        date.setHours(hours, minutes, sec);
      } else {
        date.setHours(hours, minutes);
      }
    }
  }

  static compareDate(date1: Date, date2: Date) {
    return (
      date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate()
    );
  }

  static diffDMY(date1: Date, date2: Date) {
    const d1 = dayjs(
      new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()),
    );
    const d2 = dayjs(
      new Date(date2.getFullYear(), date2.getMonth(), date2.getDate()),
    );
    return d1.diff(d2, 'day');
  }

  static isToday(date: Date) {
    return DateConverter.compareDate(new Date(), date);
  }

  static convertSecondToTimeString(time: number): string {
    const hours = Math.floor(time / 3600);
    const minutes = Math.floor((time % 3600) / 60);
    return `${hours < 10 ? '0' + hours : hours}:${
      minutes < 10 ? '0' + minutes : minutes
    }`;
  }

  static addDayToDate(date: Date, amount: number): Date {
    let m = dayjs(date);
    m = m.add(amount, 'd');
    return m.toDate();
  }

  static addWeekToDate(date: Date, amount: number): Date {
    const m = dayjs(date);
    m.add(amount, 'w');
    return m.toDate();
  }

  static isBetween(
    date: Date,
    start: Date,
    end: Date,
    granularity: OpUnitType = 'day',
    inclusivity?: '()' | '[]' | '[)' | '(]',
  ): boolean {
    const md = dayjs(date);
    const mdS = dayjs(start);
    const mdE = dayjs(end);
    return md.isBetween(mdS, mdE, granularity, inclusivity);
  }

  /**
   * return the day of the week
   * @param date
   */
  public static getISODay(date: Date): number {
    return dayjs(date).isoWeekday();
  }

  public static getWeekCountOfMonth(date: Date): number {
    const start = dayjs(date).startOf('month').isoWeek();
    const end = dayjs(date).endOf('month').isoWeek();
    if (start > end) {
      const totalNbWeek = dayjs(date).isoWeeksInYear();
      const addWeeks = totalNbWeek - start;
      return end + addWeeks + 1;
    }
    return end - start + 1;
  }
}
